/**
 * Configuration file for the Filestack file picker
 *
 * This file is where you define overrides for the default file picker parameters
 */

export default {

  /**
   * API key associated with account files should be uploaded to
   */

  stewardUrl: function() {
    return `https://steward.communityshare.org`
  },
  // https://developers.cloudflare.com/turnstile/troubleshooting/testing/
  turnstileSiteKey: "1x00000000000000000000AA", // Always passes
  // turnstileSiteKey: "1x00000000000000000000BB", // Always passes - invisible
  // turnstileSiteKey: "2x00000000000000000000AB", // always fails
  // turnstileSiteKey: "2x00000000000000000000BB", // always fails - invisible
  // turnstileSiteKey: "3x00000000000000000000FF", // forces interactive challenge
  // turnstileSiteKey: "garbage", // site key error
};
